var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{style:({position: 'fixed', left:0, right:0, top: _vm.top + 'px', zIndex:1000}),attrs:{"variant":"secondary","show":""}},[_vm._v("⌛   "+_vm._s(_vm.$t('message.waiting')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }